import cn from 'classnames';

import ContentBox from 'components/checkout/caap/ContentBox';
import ListItem from 'components/checkout/caap/ListItem';
import PurchasePromos from 'components/checkout/caap/payment/paymentlist/PurchasePromos';
import { Row, RowSpan } from 'components/checkout/caap/Layout';
import { toUSD } from 'helpers/NumberFormats';
import css from 'styles/components/checkout/caap/payment/paymentAsRadio.scss';

const PromoAsRadio = componentParams => {
  const {
    balance,
    cartType,
    eligibleBalances,
    onEditPaymentClick,
    onPaymentSelected,
    selectedPaymentId
  } = componentParams;

  const wrapperStyles = cn(css.promoWrapper, { [css.selected]: selectedPaymentId === 'savedBalance' });

  return (
    <div className={wrapperStyles}>
      <ContentBox isSolo={true} isSelected={selectedPaymentId === 'savedBalance'}>
        <ListItem
          data-paymentId="savedBalance"
          index="savedPaymentTypes"
          isChecked={selectedPaymentId === 'savedBalance'}
          itemKey="savedBalance"
          key="useGiftOrPromoBalance"
          onChange={onPaymentSelected}
          onEditItemClick={onEditPaymentClick}>
          <Row extraClass={css.content}>
            <RowSpan span="12">
              <strong>Use your {toUSD(balance)} gift card or promotional balance</strong>
            </RowSpan>
            <RowSpan span="12">
              <PurchasePromos
                cartType={cartType}
                eligibleBalances={eligibleBalances}
              />
            </RowSpan>
          </Row>
        </ListItem>
      </ContentBox>
    </div>
  );
};

export default PromoAsRadio;
